// Cave84 — the Import menu: one entry per supplier whose invoice PDF we read.
// Adding a supplier = write its parser (text → SupplierInvoice) and flip its
// status to 'ready'. The page, matching, FX and writes are shared.

import type { SupplierImporter } from './invoiceImport';
import { fromMwcInvoice } from './invoiceImport';
import { parseMwcInvoiceText } from './mwcInvoiceParser';
import { parseTomerGalInvoiceText } from './tomerGalInvoiceParser';

export const SUPPLIERS: SupplierImporter[] = [
  {
    id: 'mwc',
    name: 'Munich Wine Company',
    kind: 'Auction · Germany',
    description: "Auction invoice PDF. Buyer's premium, lot fees, shipping and VAT allocated per bottle.",
    source: 'mwc_auction',
    currency: 'EUR',
    linePriceLabel: 'Hammer',
    status: 'ready',
    parse: text => fromMwcInvoice(parseMwcInvoiceText(text)),
  },
  {
    id: 'tomer-gal',
    name: 'Tomer Gal',
    kind: 'Importer · Israel',
    description: 'Tax invoice PDF (B.W.C. Import). Prices incl. VAT in ILS, converted to EUR at the ECB rate.',
    source: 'tomer_gal',
    currency: 'ILS',
    linePriceLabel: 'Line total',
    status: 'ready',
    parse: parseTomerGalInvoiceText,
  },
  {
    id: 'burgundy-crown',
    name: 'Burgundy Crown',
    kind: 'Importer · Israel',
    description: 'Invoice PDF import — waiting for a sample invoice.',
    source: 'burgundy_crown',
    currency: 'ILS',
    linePriceLabel: 'Line total',
    status: 'coming_soon',
  },
  {
    id: 'idealwine',
    name: 'iDealwine',
    kind: 'Auction · France',
    description: 'Invoice PDF import — waiting for a sample invoice.',
    source: 'idealwine',
    currency: 'EUR',
    linePriceLabel: 'Hammer',
    status: 'coming_soon',
  },
];

export const supplierById = (id: string | undefined) => SUPPLIERS.find(s => s.id === id);
